/**
 * Web platform entry point for the React app
 */

import { createRoot } from 'react-dom/client'
import { MainWindowPlatformProvider } from '../platform/MainWindowPlatformProvider'
import { DisplayWindowPlatformProvider } from '../platform/DisplayWindowPlatformProvider'
import { WebMainWindowPlatform } from './WebMainWindowPlatform'
import { WebDisplayWindowPlatform } from './WebDisplayWindowPlatform'
import { MainWindow } from '../components/MainWindow'
import { DisplayWindow } from '../components/DisplayWindow'

// Register service worker using Vite PWA plugin (only in production builds with PWA)
if ('__PWA__' in window || import.meta.env.PROD) {
	import('virtual:pwa-register').then(({ registerSW }) => {
		registerSW({
			onNeedRefresh() {
				console.log('New content available, please refresh.')
			},
			onOfflineReady() {
				console.log('App ready to work offline.')
			},
		})
	}).catch(() => {
		// PWA not available, skip registration
		console.log('PWA not available in this build')
	})
}

// Determine which platform to use based on the query parameter
const urlParams = new URLSearchParams(window.location.search)
const isDisplayWindow = urlParams.get('view') === 'display'

// Create appropriate platform instance
const mainWindowPlatform = new WebMainWindowPlatform()
const displayWindowPlatform = new WebDisplayWindowPlatform()

const elem = document.getElementById('root')!
const app = isDisplayWindow ? (
	<DisplayWindowPlatformProvider platform={displayWindowPlatform}>
		<DisplayWindow />
	</DisplayWindowPlatformProvider>
) : (
	<MainWindowPlatformProvider platform={mainWindowPlatform}>
		<MainWindow />
	</MainWindowPlatformProvider>
)

if (import.meta.hot) {
	// With hot module reloading, `import.meta.hot.data` is persisted.
	const root = (import.meta.hot.data.root ??= createRoot(elem))
	root.render(app)
} else {
	// The hot module reloading API is not available in production.
	createRoot(elem).render(app)
}
